export enum NavbarQueryKeyEnum {
  Promotions = "PROMOTIONS",
  News = "NEWS",
  Knowtips = "KNOWTIPS",
  Vehicle = "VEHICLE",
  FAQ = "FAQ"
}
